// Filters the champion grid on the start page while typing; Enter opens the first match.
// Without JavaScript the grid still works as a plain list of links.
const normalize = (text) => text.toLowerCase().normalize("NFD").replace(/[^a-z0-9]/g, "")

document.addEventListener("input", (event) => {
  const input = event.target.closest("[data-champion-filter]")
  if (!input) return

  const query = normalize(input.value)
  const grid = document.getElementById(input.dataset.championFilter)
  let visible = 0

  grid.querySelectorAll("[data-name]").forEach((tile) => {
    const match = normalize(tile.dataset.name).includes(query)
    tile.hidden = !match
    if (match) visible += 1
  })

  const empty = document.querySelector("[data-champion-filter-empty]")
  if (empty) empty.hidden = visible > 0
})

document.addEventListener("submit", (event) => {
  const form = event.target.closest("[data-champion-search]")
  if (!form) return

  event.preventDefault()
  const first = document.querySelector("[data-name]:not([hidden]) a")
  if (first) Turbo.visit(first.href)
})
